import { Group, Loader, Text } from '@mantine/core';
import { RawModelUploadStatus } from '@/types/rawModel';
import { rawModelPendingStates } from '@/app/assets/actions/utils';

interface UploadStatusProps {
  status: RawModelUploadStatus | undefined;
  isBeingUploaded: boolean;
}

export function UploadStatus({ status, isBeingUploaded }: UploadStatusProps) {
  if (!status || (!rawModelPendingStates.has(status) && !isBeingUploaded)) {
    return null;
  }

  return (
    <Group gap='xs' wrap='nowrap'>
      <Loader color='teal' size='sm' />
      <Text size='xs' c='gray.6' style={{ textTransform: 'capitalize' }}>
        {isBeingUploaded ? 'Uploading' : (statusNamesOverrides[status] ?? status)}
      </Text>
    </Group>
  );
}

//So I don't break this https://app.clickup.com/t/86c0q35wu
//Alternatively this status name could be changed on backend, but then we might break someones API integration
const statusNamesOverrides: Partial<Record<RawModelUploadStatus, string>> = {
  RapidQC: 'QC Tools',
};
